import { defineComponent as e } from "vue";
import { MsUser as o } from "@sunrise/icons";
import { commonUtils as t } from "@sunrise/shared";
const s = e({
  name: "MsHeaderLogin",
  components: {
    MsUser: o
  },
  props: {
    link: Object
  },
  setup() {
    return {
      getRel: t.getRel
    };
  }
});
export {
  s as default
};
